<template>
  <div class="page">
    <div class="div-header-select">
      <div class="div-center">
        <div class="div-title">房源：</div>
        <el-cascader
          :props="areaProps"
          size="medium"
          v-model="areaIDSelect"
        ></el-cascader>
        <el-input
          placeholder="请输入房号"
          v-model="houseNameRegex"
          clearable
          @clear="initQuery"
          size="medium"
          maxlength="10"
          style="margin-left: 5px; width: 320px"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="initQuery"
          ></el-button>
        </el-input>
      </div>

      <div class="div-center">
        <div>到期时间：</div>
        <el-date-picker
          size="medium"
          v-model="daterange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div class="div-center">
        <el-button
          type="primary"
          size="medium"
          @click="exportFile"
          style="z-index: 30"
          >导出报表</el-button
        >
      </div>
      <!-- <div class="div-center">
        <div style="width: 60px">搜索：</div>
        <el-input
          placeholder="请输入房号"
          v-model="houseNameRegex"
          clearable @clear="initQuery"
          size="medium"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="initQuery"
          ></el-button>
        </el-input>
      </div> -->
    </div>

    <main>
      <el-table
        :data="listData"
        @filter-change="handleFilterChange"
        style="width: 100%"
        height="calc(100vh - 200px)"
      >
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column
          prop="houseName"
          label="房源"
          width="190px"
          align="center"
        >
          <template slot-scope="scope">
            <span align="center" style="padding: 5px 5px">
              <el-button
                round
                size="mini"
                style="cursor: default; padding: 5px 10px"
              >
                <div v-if="scope.row.areaName">
                  {{ scope.row.areaName }}：{{ scope.row.houseName }}
                </div>
                <div v-else>{{ scope.row.houseName }}</div>
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="leaseStartStr"
          label="租约开始时间"
          align="center"
          width="120px"
        >
        </el-table-column>
        <el-table-column prop="leaseEndStr" label="租约结束时间" align="center" width="120px"></el-table-column>
        <el-table-column prop="totalUnits" width="60px" label="租期" align="center">
        </el-table-column>
        <el-table-column prop="unit" width="100px" label="付租方式" align="center">
        </el-table-column>
        <el-table-column label="租金" align="right">
          <template slot-scope="scope">
            <strong>{{ numFormat(scope.row.rental) }}</strong>
          </template>
        </el-table-column>
        <el-table-column prop="deposit" label="押金" align="right">
          <template slot-scope="scope">
            <strong>{{ numFormat(scope.row.deposit) }}</strong>
          </template>
        </el-table-column>
        <el-table-column label="承租人" align="center" width="200px">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              content="test"
              width="400px"
              trigger="click"
            >
              <el-table :data="scope.row.renters">
                <el-table-column
                  width="150"
                  property="realname"
                  label="姓名"
                ></el-table-column>
                <el-table-column
                  width="150"
                  property="phone"
                  label="电话"
                ></el-table-column>
              </el-table>
              <div slot="reference" class="name-wrapper">
                <el-tag style="cursor: pointer" size="medium">{{
                  scope.row.renters ? scope.row.renters[0].realname : ""
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="合同" align="center"
          ><template slot-scope="scope">
            <div @click="getHetong(scope.row)" style=" cursor: pointer;">
              <el-tag  type="success" style=" cursor: pointer;"> {{scope.row.total}}</el-tag>
                
            </div> 
          </template>
        </el-table-column>
        <el-table-column
          label="租约状态"
          prop="state"
          width="180"
          column-key="state"
          :filters="[
            {
              value: '生效中',
              text: '生效中',
            },
            {
              value: '未生效',
              text: '未生效',
            },
            {
              value: '已过期',
              text: '已过期',
            },
            {
              value: '已作废',
              text: '已作废',
            },
            {
              value: '已退房',
              text: '已退房',
            },
          ]"
        >
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-button
                size="mini"
                style="padding: 5px 5px; width: 80px"
                type="success"
                round
                v-if="scope.row.state == '生效中'"
                >{{ scope.row.state }}</el-button
              >
              <el-button
                size="mini"
                style="padding: 5px 5px; width: 80px"
                type=""
                round
                v-else-if="scope.row.state == '未生效'"
                >{{ scope.row.state }}</el-button
              >
              <el-button
                size="mini"
                style="padding: 5px 5px; width: 80px"
                type="info"
                round
                v-else-if="scope.row.state == '已过期'"
                >{{ scope.row.state }}</el-button
              >
              <el-button
                size="mini"
                style="padding: 5px 5px; width: 80px"
                type="danger"
                round
                v-else-if="scope.row.state == '已作废'"
                >{{ scope.row.state }}</el-button
              >
              <el-button
                size="mini"
                style="padding: 5px 5px; width: 80px"
                type="warning"
                round
                v-else-if="scope.row.state == '已退房'"
                >{{ scope.row.state }}</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="comment" label="描述" align="center">
        </el-table-column>
      </el-table>
    </main>

    <footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIdx"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>

    <el-dialog ref="upload" :visible.sync="dialogVisible" title="上传合同" width="40%" :close-on-click-modal="false" :close-on-press-escape="false" >
      <div style="color:red;font-size:12px;margin-bottom:10px">
        注：新上传的文件会覆盖之前的文件
      </div>
      <el-upload :show-file-list="false"  :http-request="uploadSectionFile" class="upload-demo"
        drag :data="uploadData"  :headers="getHeaders()"  :action="uploadUrl" >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </el-dialog>
    <!-- 合同列表 --> 
      <el-dialog :title="hetongTitle"  :visible.sync="hetongVisible" :before-close="handleClose" width="70%"  :close-on-click-modal="false">
        <div style="width:100px" >
           <el-button type="primary" @click="addHetong">新增合同</el-button>
        </div>
        <div v-loading="hetongLoading">
           <el-table :data="tableData" style="width: 100%">
              <el-table-column  prop="name"  label="合同名称"  > </el-table-column>
              <el-table-column prop="type" label="合同类型" > </el-table-column>
              <el-table-column  prop="signType" label="签署方式"> </el-table-column> 
              <el-table-column  prop="state" label="状态"> </el-table-column> 
               <el-table-column label="操作" width="220">
                <template slot-scope="scope"> 
                  <el-tooltip v-if="scope.row.signType=='在线签署'&&scope.row.state=='待签署'"  class="item" effect="dark" content="线上签署" placement="top">
                      <el-button  type="primary"  @click="handleEdit( scope.row,null)"
                      icon="el-icon-edit-outline" circle ></el-button> 
                  </el-tooltip>  
                  <el-tooltip v-else class="item" effect="dark" content="预览" placement="top">
                      <el-button type="info"   icon="el-icon-view" circle @click="handleEdit(scope.row,true)"></el-button> 
                  </el-tooltip> 
                  <el-tooltip class="item" effect="dark" content="上传附件" placement="top">
                      <el-button type="warning" v-if="scope.row.signType=='线下签署'"   icon="el-icon-upload" circle @click="addItem(scope.row)"></el-button> 
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="下载" placement="top">
                     <el-button  type="success" icon="el-icon-download" circle  @click="downloadFile(scope.row)"></el-button> 
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="top">
                     <el-button  type="danger"  icon="el-icon-delete-solid" circle  @click="handleDelete(scope.row)"></el-button> 
                  </el-tooltip>

                  <!-- <el-button size="mini"></el-button>
                  <el-button size="mini" ></el-button>
                  <el-button size="mini" ></el-button>
                  <el-button size="mini" type="success"></el-button>
                  <el-button size="mini" type="danger"></el-button> -->
                </template>
              </el-table-column>
            </el-table>
        </div> 
      </el-dialog>
      <!-- 新增合同 -->
       <el-dialog title="创建合同"  :visible.sync="addHetongVisible"  width="30%"   :close-on-click-modal="false"> 
        <div>
           <el-form ref="formContractInputForm" :model="formContractInput" label-width="80px">
            <el-form-item label="合同名称">
              <div style="width:215px">
                <el-input :placeholder="placeholderName" v-model="formContractInput.contractName" ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="合同类型">
              <div style="width:215px">
                  <el-radio-group v-model="formContractInput.contractType"  @change="changeType" >
                    <el-radio label="租赁合同">租赁合同</el-radio>
                    <el-radio label="其它合同">其它合同</el-radio> 
                  </el-radio-group>
                <!-- <el-select v-model="formContractInput.contractType"  placeholder="请选择合同类型">
                  <el-option label="租赁合同" value="租赁合同"></el-option>
                  <el-option label="其它合同" value="其它合同"></el-option>
                </el-select> -->
               </div>
            </el-form-item>
            <el-form-item label="签署方式">
              <div style="width:215px">
                <el-radio-group v-model="formContractInput.signType"  >
                  <div style="display:flex"> 
                    <el-radio label="在线签署">在线签署
                       <el-tooltip class="item" effect="dark" content="线上签署电子合同" placement="top-start">
                            <i class="el-icon-info"></i> 
                        </el-tooltip> 
                    </el-radio>
                    <el-radio label="线下签署">线下签署
                       <el-tooltip class="item" effect="dark" content="线下签署后上传合同附件" placement="top-start">
                          <i class="el-icon-info"></i>
                        </el-tooltip> 
                    </el-radio>
                  </div> 
                  </el-radio-group>
                <!-- <el-select v-model="formContractInput.signType"   placeholder="请选择合同类型">
                  <el-option label="在线签署	" value="在线签署"></el-option>
                  <el-option label="线下签署" value="线下签署"></el-option>
                </el-select> -->
              </div>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addHetongVisible = false">取 消</el-button> 
          <el-button type="primary" @click="submiContract">确 认</el-button>
         <div style="margin-top:10px" v-if="this.formContractInput.signType=='在线签署'" >
            <el-checkbox v-model="checked">
               <div @click="seeXieYi=true" style="color:blue">勾选即表示同意《数字证书使用协议》</div>
            </el-checkbox>
          </div>
        </span>
      </el-dialog>
      <el-dialog :title="formContractInput.name " top="1vh" :visible.sync="seeXieYi" width="90%" :close-on-click-modal="false">
        <iframe style="top: 0px;width:100%; height: 70vh;scrolling:no" src="https://web.hytsmart.com/agreements/ca.html" frameborder="0" ></iframe>
        <span slot="footer" class="dialog-footer">
            <el-button @click="seeXieYi = false">关闭</el-button> 
         </span>
      </el-dialog>
       <!-- 预览在线合同 并签署--> 
      <el-dialog title="" top="1vh"  :visible.sync="previewVisible" width="90%"   :close-on-click-modal="false">
        <div style="font-size:24px;margin-top:-50px">{{previewData.name}}</div>
        <div style=" display: flex;justify-content: space-around;margin:20px 0">
          <div><span style="color:blue;margin:0 10px">合同类型:</span>{{previewData.type}}</div>
          <div><span style="color:blue;margin:0 10px">签署方式:</span>{{previewData.signType}}</div>
          <div><span style="color:blue;margin:0 10px">状态:</span>{{previewData.state}}</div>
        </div>
        <div>
          <iframe style=" ;width:100%; height: 67vh;" :src="viewUrl" frameborder="0"></iframe>
        </div>
        <span slot="footer" class="dialog-footer" v-if="!isYuLan"> 
          <el-button type="primary" @click="handleSign" >确 认 签 署</el-button>
           
        </span>
      </el-dialog>
  </div>
</template>

<script>
import Utils from "../../Utils";
import { Loading } from "element-ui";
import axios from "axios";
import mixins from "../../minix";

export default {
  name: "Contract",

  mixins: [mixins],

  watch: {
    areaIDSelect() {
      this.initQuery();
    },

    daterange() {
      this.initQuery();
    },
  },

  data() {
    return {
      num: 0,
      stateList: [],
      checked:false,
      seeXieYi:false,
      dialogVisible: false,
      hetongVisible:false,
      addHetongVisible:false,
      previewVisible:false,
      hetongLoading:false,
      tableData:[],
      formContractInput:{},
      leaseID:'',
      isYuLan:null,
      viewUrl:'',
      qianshuID:'',
      uploadUrl: "",
      queryState: false,
      showInput: false,
      uploadData: {
        orgID:"",
        leaseID: "",
      },
      daterange: "",
         newDay:'',
       placeholderName:'',
       hetongTitle:'',
       previewData:{},
       
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");
    this.query(0);
     this.newDay = this.getYMDHMS(new Date().getTime()).substring(0,11).replace(/-/g,'');
    this.placeholderName = "租赁合同"+this.newDay;
    
  },

  methods: {
    // 时间转换
    getYMDHMS(timestamp){
        let time = new Date(timestamp)
        let year = time.getFullYear()
        let month = time.getMonth() + 1
        let date = time.getDate()
        let hours = time.getHours()
        let minute = time.getMinutes()
        let second = time.getSeconds()

        if (month < 10) { month = '0' + month }
        if (date < 10) { date = '0' + date }
        if (hours < 10) { hours = '0' + hours }
        if (minute < 10) { minute = '0' + minute }
        if (second < 10) { second = '0' + second }
        return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
    },
    // 切换合同类型
    changeType(e){ 
       this.placeholderName = e+this.newDay  
      this.$forceUpdate();
    },
    // 关闭合同列表页面
    handleClose(){
      this.hetongVisible = false;
       this.query(0);
    },
    // 点击合同
    getHetong(item){ 
      this.leaseID = item.leaseID; 
      this.getHetongList() 
      this.hetongTitle = "【 "+item.areaName+" "+item.houseName+" 】 合同列表"
       this.hetongVisible = true;
    },
    // 获取合同列表
    getHetongList(){ 
        //  const loading = Loading.service({
        //   lock: true,
        //   text: "加载中",
        //   spinner: "el-icon-loading",
        //   background: "rgba(0, 0, 0, 0.1)",
        // });
         this.hetongLoading = true;
      let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
      axios({
        method: "post",
        url: v2BaseURL+"leases/contracts",
        data: {
          leaseID: this.leaseID,
          pageIdx:0,
          pageSize:100,
          orgID:this.$route.query.orgID
        },
      }).then((value) => { 
          let message = value.data.message; 
          if (value.data.code === 0) {
             this.tableData = [...value.data.data];  
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        }).finally(()=>{
            this.hetongLoading = false;
        });  
    },
    // 新增合同
    addHetong(){ 
        this.formContractInput = {
          contractName: "",
          contractType: "租赁合同",
          signType: "",
        };
         this.placeholderName = "租赁合同"+this.newDay;
        this.addHetongVisible = true;
    },
    // 删除合同
    handleDelete(e){ 
        this.$confirm(
        `此操作将删除合同【 ${e.name} 】, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
          const loading = Loading.service({
              lock: true,
              text: "加载中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.1)",
            });
          let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
          axios({
            method: "post",
            url: v2BaseURL+"leases/contracts/delete",
            data: {
              leaseID: this.leaseID,
              contractID: e.id,
              orgID:this.$route.query.orgID
            },
          }).then((value) => { 
             loading.close();
              if (value.data.code === 0) {
                this.$message.success("删除成功"); 
                // 刷新数据
                this.getHetongList()
              } else {
                this.$message.error("删除失败");
              }
            })
            .catch(() => {
               loading.close();
              this.$message.error("操作失败");
            });
        })
        .catch(() => {});
    },
    // 合同弹框确定
    submiContract(){ 
       if(!this.checked&&this.formContractInput.signType=='在线签署'){
        return this.$message.error('请同意《数字证书使用协议》')
      }
        if(this.formContractInput.contractName=='' ){
          // this.$message.error("请填写合同名称！")
          this.formContractInput.contractName = this.placeholderName;
        }
        if( this.formContractInput.contractType=='' ){
          return this.$message.error("请选择合同类型！")
        }
          if( this.formContractInput.signType==''){
          return this.$message.error("请选择签署方式！")
        }
        let data = { ...this.formContractInput };
        data.leaseID = this.leaseID;
        data.orgID = this.$route.query.orgID; 

        const loading = Loading.service({
          lock: true,
          text: "加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
      let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
      axios({
        method: "post",
        url: v2BaseURL+"leases/contracts/add",
        data: data,
      }).then((value) => {
        this.checked = false;
          let message = value.data.message;
          if (value.data.code === 0) {
            this.$message.success("新增成功");
            this.addHetongVisible = false;
            this.getHetongList() 
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          loading.close();
        });
    },
    handleFilterChange(val) {
      this.stateList = val.state;
      this.query(0);
    },
    handleCurrentChange(val) {
      this.pageIdx = val;
      this.query(val - 1);
    },

    querySearch(queryString, cb) {
      cb(this.areasList);
    },

    handleSizeChange(val) {
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },

    initQuery() {
      this.pageIdx = 0;
      this.query(this.pageIdx);
    },
    // 上传附件
    uploadSectionFile(params) { 
      this.$confirm('此操作将会覆盖之前的附件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           const file = params.file;
            // 根据后台需求数据格式
            const form = new FormData();
            // 文件对象
            form.append("file", file);
            // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
            form.append("leaseID", this.leaseID);
            form.append("orgID",this.$route.query.orgID);
            form.append("contractID",this.contractID);
            // 项目封装的请求方法，下面做简单介绍
            this.uploadUrl = axios.defaults.baseURL.replace("/v1/org", "/v2") + "leases/contracts/upload"; 
            axios
              .post(this.uploadUrl, form)
              .then((value) => {
                if (value.data.code === 0) {
                  this.$message.success("上传成功");
                  this.dialogVisible = false;
                  // this.initQuery();
                  this.getHetongList()
                } else {
                  this.$message.error(value.data.message);
                }
              })
              .catch((reason) => {
                this.$message.error(reason.toString());
              })
              .finally(() => {
                this.$refs.upload.clearFiles();
              });
          
        }).catch(() => {          
        });
     
    },
    //导出报表
    async exportFile() {
      let file = "";
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
      let base = axios.defaults.baseURL.replace("/v1", "/v2");
      await axios({
        method: "post",
        url:`${base}leases/contracts/export` ,
        data: {
          orgID:localStorage.getItem('orgID')
        },
      })
        .then((value) => {
          if (value.data.code != 0) {
            loading.close();
            this.$message.error(value.data.message);
          } else {
            file = value.data.data;
          }
        })
        .catch(() => {});

      if (file === "") return  this.$message.error("无效的文件"); // 没有获取到文件名时，不启动下载

      let baseURL = axios.defaults.baseURL.replace("/v1/org", "");

      await axios({
        method: "get",
        url: `${baseURL}public/${file}`,
        responseType: "blob",
      })
        .then((value) => { 
          Utils.convertRes2Blob(file, value);
          this.$message.success("文件下载成功");
        })
        .catch((e) => {
          this.$message.error(e.toString());
        })
        .finally(() => {
          loading.close();
        });
    },
    // 获取电子合同
    preview(e){
       this.viewUrl = "";
        const loading = Loading.service({
          lock: true,
          text: "加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
       let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
      axios({
        method: "post",
        url: v2BaseURL+"leases/contracts/preview",
        data:{
          contractID:e,
          leaseID:this.leaseID,
          orgID:this.$route.query.orgID,
        },
      }).then((value) => {
          let message = value.data.message;
          if (value.data.code === 0) {  
             this.previewVisible = true;
            this.viewUrl = value.data.data;
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          loading.close();
        });
    },
    // 确认签署
    handleSign(){
       this.$confirm('已进入安全签约环境，即将调用您的数字证书进行合同签署, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            const loading = Loading.service({
                  lock: true,
                  text: "加载中",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.1)",
                });
              let v2BaseURL = axios.defaults.baseURL.replace("/v1/org", "/v2");
              axios({
                method: "post",
                url: v2BaseURL+"leases/contracts/landlordsign",
                data: {
                  leaseID:this.leaseID,
                  contractID:this.qianshuID,
                  orgID:this.$route.query.orgID
                },
              }).then((value) => {
                  let message = value.data.message;
                  if (value.data.code === 0) { 
                    this.$message.success("签署成功");
                    if(this.contractVisibleDetail){
                          this.getContractDetail(this.contractId)
                      }
                      // 刷新数据
                    this.getHetongList();
                    this.previewVisible = false  

                  } else {
                    this.$message.error(message);
                  }
                })
                .catch(() => {
                  this.$message.error("操作失败");
                })
                .finally(() => {
                  loading.close();
                });
        })
        
    },
    // 点击线上签署
    handleEdit(e,l){ 
      this.qianshuID = e.id;
      this.isYuLan = l; 
      this.previewData = e;
      this.preview(e.id)
       
    },
    // 点击上传附件
    addItem(item) {   
      this.contractID = item.id;
      this.dialogVisible = true;
      this.uploadData.leaseID = this.leaseID;
      this.uploadData.orgID = this.$route.query.orgID;
    },
    // 下载附件
    async downloadFile(item) { 
       const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });
      let file=""
      let baseURL = axios.defaults.baseURL.replace("/v1/org", "/v2"); 
      await axios({
        method: "POST",
        url: `${baseURL}leases/contracts/download`,
        data: {
          orgID:localStorage.getItem('orgID'),
          leaseID:this.leaseID,
          contractID:item.id,
        },
      }).then((value) => {
          if(value.data.code==0){ 
             file = value.data.data;  
          }else{
             loading.close();
            this.$message.error(value.data.message)
          }
         
        }).catch((e) => {
           loading.close();
          this.$message.error(e.toString());
        }); 
        if (file === "") return // 没有获取到文件名时，不启动下载
           if(item.signType=="在线签署"){ 
              loading.close();
              window.open(file);
          }else{
              let base = axios.defaults.baseURL.replace("/v1/org/", ""); 
              await axios({
                method: "get",
                url: `${base}${file}`,
                responseType: "blob",
              }).then((value) => { 
                  Utils.convertRes2Blob(file, value);
                  this.$message.success("文件下载成功");
                }).catch((e) => {
                  this.$message.error("文件下载失败");
                }).finally(() => {
                  loading.close();
                });
          }
    },

    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        houseID: this.houseID,
        pageSize: this.pageSize,
        pageIdx: pageIdx,
        houseNameRegex: this.houseNameRegex,
      };
      if (this.stateList.length > 0) {
        data.states = this.stateList;
      }
      if (Array.isArray(this.daterange)) {
        data.eStart = parseInt(this.daterange[0].getTime() / 1000);
        data.eEnd = parseInt(
          this.daterange[1].getTime() / 1000 + 60 * 60 * 24 - 1
        );
      }

      if (this.areaIDSelect.length > 0) {
        data.areaID = this.areaIDSelect[this.areaIDSelect.length - 1];
      }

      const loading = Loading.service({
        lock: true,
        text: "加载列表中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      axios({
        method: "post",
        url: "leases/contracts/query",
        data: data,
      })
        .then((value) => {
          this.queryState = false;
          this.num = 0;
          if (value.data.code != 0) {
            loading.close();
            this.$message.error(value.data.message);
            return;
          }
          this.listData = [];
          this.itemTotal = value.data.total;
          if (value && value.data && value.data.data) {
            value.data.data.forEach((item) => {
              item.leaseStartStr = Utils.long2day(item.leaseStart * 1000);
              item.leaseEndStr = Utils.long2day(item.leaseEnd * 1000);
              item.canceledStr = item.canceled ? "是" : "否";
              item.rental = item.rental / 100;
              item.deposit = item.deposit / 100;
              this.listData.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style.css";
main {
  margin-top: 10px;
 
 
}
</style>
